import { useMemo } from 'react'
import useJobCategoryStore from '../store/store.jobCategory'
import { TJobCategory } from '../type/jobCategoryStoreType'

const useLeftSection = () => {
  const activeIds = useJobCategoryStore((state) => state.activeIds)
  const idsByDepth = useJobCategoryStore((state) => state.idsByDepth)
  const getCategoriesByIds = useJobCategoryStore(
    (state) => state.getCategoriesByIds,
  )
  const activeId = useJobCategoryStore((state) => state.activeId)

  const selectId = useJobCategoryStore((state) => state.selectId)

  const isFirstDepth = activeIds.length < 2

  const leftSectionItem = useMemo(() => {
    const depthCursor = isFirstDepth ? 1 : 2
    const resultIds = idsByDepth?.[depthCursor]

    const result = getCategoriesByIds(resultIds).filter((category) => {
      if (isFirstDepth) {
        return true
      }

      return category.parentId === activeIds[0]
    })

    return result
  }, [activeIds, idsByDepth, getCategoriesByIds, isFirstDepth])

  const getIsActiveId = (id: string) => {
    return activeIds.includes(id as never)
  }

  const handleItemClick = (category: TJobCategory) => {
    activeId(category.id)
    if (!isFirstDepth && category.selectedChildrenIds.length === 0) {
      selectId(category.id)
    }
  }

  const handleBackButtonClick = () => {
    if (activeIds[0]) {
      activeId(activeIds[0])
    }
  }

  return {
    isFirstDepth,
    leftSectionItem,
    getIsActiveId,
    onItemClick: handleItemClick,
    onBackButtonClick: handleBackButtonClick,
  }
}

export default useLeftSection
